import axios from "axios";
import { toast } from "react-toastify";
import { URL } from "../common/url";
import api from "../common/api";
import {
  LOADING,
  CITY_LIST,
  SLIDER_LIST,
  AREA_LIST,
  OCCASION_LIST,
  FUNCTION_LIST,
  ESSENTIAL_LIST,
  ESSENTIAL_TYPE_LIST,
  DASHBOARD,
  ORDER_LIST,
  ORDER_DETAIL_LIST,
   BOOKING_LIST,
  VENUES_LIST,
  GALLERY_LIST,
  YOUTUBE_LIST,
  USER_LIST,
} from "../common/constant";

const loading = (data) => {
  return { type: LOADING, payload: data };
};
const dashboardAction = (data) => {
  return { type: DASHBOARD, payload: data };
};
const cityListAction = (data) => {
  return { type: CITY_LIST, payload: data };
};
const areaListAction = (data) => {
  return { type: AREA_LIST, payload: data };
};
const sliderListAction = (data) => {
  return { type: SLIDER_LIST, payload: data };
};
const occasionListAction = (data) => {
  return { type: OCCASION_LIST, payload: data };
};
const functionListAction = (data) => {
  return { type: FUNCTION_LIST, payload: data };
};
const venuesListAction = (data) => {
  return { type: VENUES_LIST, payload: data };
};
const essentialListAction = (data) => {
  return { type: ESSENTIAL_LIST, payload: data };
};
const essentialTypeListAction = (data) => {
  return { type: ESSENTIAL_TYPE_LIST, payload: data };
};
const orderListAction = (data) => {
  return { type: ORDER_LIST, payload: data };
};
const orderDetailsListAction = (data) => {
  return { type: ORDER_DETAIL_LIST, payload: data };
};

const bookingListAction = (data) => {
  return { type: BOOKING_LIST, payload: data };
};

const galleryListAction = (data) => {
  return { type: GALLERY_LIST, payload: data };
};

const youtubeListAction = (data) => {
  return { type: YOUTUBE_LIST, payload: data };
};

const userListAction = (data) => {
  return { type: USER_LIST, payload: data };
};


// Dashboard APi's
export const dashboard = () => {

  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");

      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.get(`${URL.dashboard}`, config);
      if (response?.data?.status) {
        dispatch(dashboardAction(response?.data?.data));
      } else {
        toast.error(response?.data?.message, { toastId: "dashboardData" });
        dispatch(dashboardAction(response?.data?.data));
      };
      dispatch(loading(false));
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
    }
  };
};

// admin login
export const userLogin = (data, navigate) => {
  return async (dispatch) => {
    try {
      const response = await api.post(`${URL.login_admin}`, data);
      if (response?.status == 200) {
        if (response?.data?.status == true) {
          // dispatch(otpBoxAction(true));
          localStorage.setItem("admin_token", response?.data?.data?.api_token);
          navigate("/");
          toast.success(response?.data?.message);
        } else {
          toast.error(response?.data?.message);
        }
        // otpBoxAction
        // Token.setToken(response?.data?.api_token);
        // setTimeout(navigate("/vendor"), 1000);
        dispatch(loading(false));
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      dispatch(loading(false));
      toast.error(error?.response?.data?.message);
    }
  };
};

// cities
export const getCities = (params) => {
  const queryParams = new URLSearchParams(params);
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");

      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.get(`${URL.get_cities}?${queryParams}`, config);
      if (response?.data?.status) {
        dispatch(cityListAction(response?.data?.data));
      } else {
        toast.error(response?.data?.message, { toastId: "getCities" });
        dispatch(cityListAction(response?.data?.data));
      };
      dispatch(loading(false));
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
    }
  };
};
export const addCity = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.post(`${URL.add_city}`, data, config);

      if (response?.data?.status) {
        toast.success(response?.data?.message, { toastId: "addCity" });
      } else {
        toast.error(response?.data?.message);
      }
      dispatch(loading(false));
      return response?.data;
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
      return error?.response?.data;
    }
  };
};
export const updateCity = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const res = await api.post(`${URL.update_city}`, data, config);
      if (res?.data?.status) {
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message);
      };
      dispatch(loading(false));
      return res?.data;
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.res?.data?.message);
      return error?.res?.data;
    }
  };
};
export const deleteCity = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");

      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.post(`${URL.delete_city}`, data, config);
      if (response?.data?.status) {
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message, { toastId: "deleteCity" });
      }

      dispatch(loading(false));

      return response?.data;
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
      return error?.response?.data;
    }
  };
};

// Area
export const getAreas = (params) => {
  const queryParams = new URLSearchParams(params);
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");

      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.get(`${URL.get_areas}?${queryParams}`, config);
      if (response?.data?.status) {
        dispatch(areaListAction(response?.data?.data));
      } else {
        toast.error(response?.data?.message, { toastId: "getAreas" });
        dispatch(areaListAction(response?.data?.data));
      };
      dispatch(loading(false));
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
    }
  };
};
export const addArea = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.post(`${URL.add_area}`, data, config);

      if (response?.data?.status) {
        toast.success(response?.data?.message, { toastId: "addArea" });
      } else {
        toast.error(response?.data?.message);
      }
      dispatch(loading(false));
      return response?.data;
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
      return error?.response?.data;
    }
  };
};
export const updateArea = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const res = await api.post(`${URL.update_area}`, data, config);
      if (res?.data?.status) {
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message);
      };
      dispatch(loading(false));
      return res?.data;
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.res?.data?.message);
      return error?.res?.data;
    }
  };
};
export const deleteArea = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");

      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.post(`${URL.delete_area}`, data, config);
      if (response?.data?.status) {
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message, { toastId: "deleteArea" });
      }

      dispatch(loading(false));

      return response?.data;
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
      return error?.response?.data;
    }
  };
};

// Banner Slider
export const getSliders = (data, history) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.get(`${URL.get_sliders}?page=${data}`, config);
      if (response?.data?.status) {
        dispatch(sliderListAction(response?.data?.data));
      } else {
        toast.error(response?.data?.message);
      };
      dispatch(loading(false));
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
    }
  };
};
export const createSlider = (data, history) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.post(`${URL.create_slider}`, data, config);

      if (response?.data?.status) {
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message);
      }
      dispatch(loading(false));
      return response?.data;
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
      return error?.response?.data;
    }
  };
};
export const updateSlider = (data, history) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const res = await api.post(`${URL.update_slider}`, data, config);
      if (res?.data?.status) {
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message);
      };
      dispatch(loading(false));
      return res?.data;
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.res?.data?.message);
      return error?.res?.data;
    }
  };
};
export const deleteSlider = (data, history) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");

      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      dispatch(loading(true));
      const response = await api.post(`${URL.delete_slider}`, data, config);
      if (response?.data?.status) {
        toast.success(response?.data?.message);
        dispatch(sliderListAction(response?.data?.data));
      } else {
        toast.error(response?.data?.message);
      };

      dispatch(loading(false));
      return response?.data;
    } catch (error) {
      dispatch(loading(false));
      return error?.response?.data;
      // toast.error(error?.response?.data?.message);
    }
  };
};

// Occasion
export const getOccasions = (params) => {
  const queryParams = new URLSearchParams(params);
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");

      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.get(`${URL.get_occasions}?${queryParams}`, config);
      if (response?.data?.status) {
        dispatch(occasionListAction(response?.data?.data));
      } else {
        toast.error(response?.data?.message, { toastId: "getOccasions" });
        dispatch(occasionListAction(response?.data?.data));
      };
      dispatch(loading(false));
    } catch (error) {
      dispatch(loading(false));
    }
  };
};
export const addOccasion = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.post(`${URL.create_occasion}`, data, config);

      if (response?.data?.status) {
        toast.success(response?.data?.message, { toastId: "addOccasion" });
      } else {
        toast.error(response?.data?.message);
      }
      dispatch(loading(false));
      return response?.data;
    } catch (error) {
      dispatch(loading(false));
      return error?.response?.data;
    }
  };
};
export const updateOccasion = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const res = await api.post(`${URL.update_occasion}`, data, config);
      if (res?.data?.status) {
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message);
      };
      dispatch(loading(false));
      return res?.data;
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.res?.data?.message);
      return error?.res?.data;
    }
  };
};
export const deleteOccasion = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");

      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.post(`${URL.delete_occasion}`, data, config);
      if (response?.data?.status) {
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message, { toastId: "deleteOccasion" });
      }
      dispatch(loading(false));
      return response?.data;
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
      return error?.response?.data;
    }
  };
};

// Functions
export const getFunctions = (params) => {
  const queryParams = new URLSearchParams(params);
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");

      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.get(`${URL.get_functions}?${queryParams}`, config);
      if (response?.data?.status) {
        dispatch(functionListAction(response?.data?.data));
      } else {
        toast.error(response?.data?.message, { toastId: "getFunctions" });
        dispatch(functionListAction(response?.data?.data));
      };
      dispatch(loading(false));
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
    }
  };
};
export const addFunction = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.post(`${URL.add_function}`, data, config);

      if (response?.data?.status) {
        toast.success(response?.data?.message, { toastId: "addFunction" });
      } else {
        toast.error(response?.data?.message);
      }
      dispatch(loading(false));
      return response?.data;
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
      return error?.response?.data;
    }
  };
};
export const updateFunction = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const res = await api.post(`${URL.update_function}`, data, config);
      if (res?.data?.status) {
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message);
      };
      dispatch(loading(false));
      return res?.data;
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.res?.data?.message);
      return error?.res?.data;
    }
  };
};
export const deleteFunction = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");

      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.post(`${URL.delete_function}`, data, config);
      if (response?.data?.status) {
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message, { toastId: "deleteFunction" });
      }

      dispatch(loading(false));

      return response?.data;
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
      return error?.response?.data;
    }
  };
};

// Venues
export const getVenues = (params) => {
  const queryParams = new URLSearchParams(params);
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");

      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.get(`${URL.get_venues}?${queryParams}`, config);
      if (response?.data?.status) {
        dispatch(venuesListAction(response?.data?.data));
      } else {
        toast.error(response?.data?.message, { toastId: "getVenues" });
        dispatch(venuesListAction(response?.data?.data));
      };
      dispatch(loading(false));
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
    }
  };
};
export const addVenue = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.post(`${URL.add_venue}`, data, config);

      if (response?.data?.status) {
        toast.success(response?.data?.message, { toastId: "addVenue" });
      } else {
        toast.error(response?.data?.message);
      }
      dispatch(loading(false));
      return response?.data;
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
      return error?.response?.data;
    }
  };
};

// Updated updateVenue action
export const updateVenue = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const res = await api.post(`${URL.update_venue}`, data, config);
      if (res?.data?.status) {
        toast.success(res?.data?.message);
        dispatch(venuesListAction(res?.data?.data)); // Dispatch updated venue data
      } else {
        toast.error(res?.data?.message);
      }
      dispatch(loading(false));
      return res?.data;
    } catch (error) {
      dispatch(loading(false));
      toast.error(error?.response?.data?.message || "Failed to update venue");
      return error?.response?.data;
    }
  };
};

export const deleteVenue = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");

      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.post(`${URL.delete_venue}`, data, config);
      if (response?.data?.status) {
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message, { toastId: "deleteVenue" });
      }

      dispatch(loading(false));

      return response?.data;
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
      return error?.response?.data;
    }
  };
};

// Essentials
export const getEssentials = (params) => {
  const queryParams = new URLSearchParams(params);
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");

      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.get(`${URL.get_essentials}?${queryParams}`, config);
      if (response?.data?.status) {
        dispatch(essentialListAction(response?.data?.data));
      } else {
        toast.error(response?.data?.message, { toastId: "getEssentials" });
        dispatch(essentialListAction(response?.data?.data));
      };
      dispatch(loading(false));
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
    }
  };
};
export const addEssential = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.post(`${URL.add_essential}`, data, config);

      if (response?.data?.status) {
        toast.success(response?.data?.message, { toastId: "addEssential" });
      } else {
        toast.error(response?.data?.message);
      }
      dispatch(loading(false));
      return response?.data;
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
      return error?.response?.data;
    }
  };
};
export const updateEssential = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const res = await api.post(`${URL.update_essential}`, data, config);
      if (res?.data?.status) {
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message);
      };
      dispatch(loading(false));
      return res?.data;
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.res?.data?.message);
      return error?.res?.data;
    }
  };
};
export const deleteEssential = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");

      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.post(`${URL.delete_essential}`, data, config);
      if (response?.data?.status) {
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message, { toastId: "deleteEssential" });
      }

      dispatch(loading(false));

      return response?.data;
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
      return error?.response?.data;
    }
  };
};

// Essential Types
export const getEssentialTypes = (params) => {
  const queryParams = new URLSearchParams(params);
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");

      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.get(`${URL.get_essential_types}?${queryParams}`, config);
      if (response?.data?.status) {
        dispatch(essentialTypeListAction(response?.data?.data));
      } else {
        toast.error(response?.data?.message, { toastId: "getEssentialTypes" });
        dispatch(essentialTypeListAction(response?.data?.data));
      };
      dispatch(loading(false));
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
    }
  };
};
export const addEssentialType = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.post(`${URL.add_essential_type}`, data, config);

      if (response?.data?.status) {
        toast.success(response?.data?.message, { toastId: "addEssentialType" });
      } else {
        toast.error(response?.data?.message);
      }
      dispatch(loading(false));
      return response?.data;
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
      return error?.response?.data;
    }
  };
};
export const updateEssentialType = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const res = await api.post(`${URL.update_essential_type}`, data, config);
      if (res?.data?.status) {
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message);
      };
      dispatch(loading(false));
      return res?.data;
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.res?.data?.message);
      return error?.res?.data;
    }
  };
};
export const deleteEssentialType = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");

      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.post(`${URL.delete_essential_type}`, data, config);
      if (response?.data?.status) {
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message, { toastId: "deleteEssentialType" });
      }

      dispatch(loading(false));

      return response?.data;
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
      return error?.response?.data;
    }
  };
};

//Orders
// Banner Slider
export const getOrders = (data, history) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");

      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };

      const page = data?.page || 1;
      const search = data?.search || "";

      const response = await api.get(
        `${URL.get_orders}?page=${page}&search=${encodeURIComponent(search)}`,
        config
      );

      if (response?.data?.status) {
        dispatch(orderListAction(response?.data?.data));
      } else {
        toast.error(response?.data?.message);
      }

      dispatch(loading(false));
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
    }
  };
};


export const deleteOrder = (data, history) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");

      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      dispatch(loading(true));
      const response = await api.post(`${URL.delete_order}`, data, config);
      if (response?.data?.status) {
        toast.success(response?.data?.message, { toastId: "deleteOrder" });
        dispatch(orderListAction(response?.data?.data));
      } else {
        toast.error(response?.data?.message, { toastId: "deleteOrder" });
      };

      dispatch(loading(false));
      return response?.data;
    } catch (error) {
      dispatch(loading(false));
      return error?.response?.data;
      // toast.error(error?.response?.data?.message);
    }
  };
};

//Order Details
export const getOrderDetail = (data, history) => {
  return async (dispatch) => {
    try {
      dispatch(loading(true));
      const token = await localStorage.getItem("admin_token");
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const response = await api.post(`${URL.get_order_detail}`, data, config);
      if (response?.data?.status) {
        dispatch(orderDetailsListAction(response?.data?.data));
      } else {
        toast.error(response?.data?.message);
      };
      dispatch(loading(false));
    } catch (error) {
      console.error("error ==> ", error);
      dispatch(loading(false));
      // toast.error(error?.response?.data?.message);
    }
  };
};
export const updateOrder = (data, history) => {
  return async (dispatch) => {
    try {
      dispatch(loading(true));
      const token = await localStorage.getItem("admin_token");
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const res = await api.post(`${URL.update_order}`, data, config);
      if (res?.data?.status) {
        dispatch(getOrderDetail({ order_id: data.order_id }));
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message);
      };
      dispatch(loading(false));
      return res?.data;
    } catch (error) {
      dispatch(loading(false));
      // toast.error(error?.res?.data?.message);
      return error?.res?.data;
    }
  };
};


/* =========================
   BOOKINGS
========================= */

export const getBookings = (params = {}) => {
  return async (dispatch) => {
    // Clear previous function's bookings immediately
    dispatch(bookingListAction({ data: [] }));

    try {
      const token = localStorage.getItem("admin_token");

      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };

      const query = new URLSearchParams();

      query.append(
        "order_function_id",
        String(params.order_function_id)
      );
      query.append("page", String(params.page || 1));

      if (params.status) {
        query.append("status", params.status);
      }

      const response = await api.get(
        `${URL.get_bookings}?${query.toString()}`,
        config
      );

      if (response?.data?.status) {
        // Handle null or missing API data
        dispatch(
          bookingListAction(response?.data?.data ?? { data: [] })
        );
      } else {
        // Clear stale data if the API returns an unsuccessful response
        dispatch(bookingListAction({ data: [] }));

        toast.error(
          response?.data?.message || "Failed to fetch bookings"
        );
      }

      return response?.data;
    } catch (error) {
      // Clear old bookings if the request fails
      dispatch(bookingListAction({ data: [] }));

      toast.error(
        error?.response?.data?.message ||
          "Failed to fetch bookings"
      );

      throw error;
    }
  };
};

export const updateBookingStatus = (data) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem("admin_token");

      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };

      const payload = {
        booking_id: data.booking_id,
        status: data.status,
      };

      if (data.cancel_reason) {
        payload.cancel_reason = data.cancel_reason;
      }

      const response = await api.post(
        URL.update_booking_status,
        payload,
        config
      );

      if (response?.data?.status) {
        toast.success(
          response?.data?.message ||
            "Booking status updated successfully"
        );
      } else {
        toast.error(
          response?.data?.message ||
            "Failed to update booking status"
        );
      }

      return response?.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Failed to update booking status"
      );

      throw error;
    }
  };
};

// Gallery
export const getGallery = (params) => {
  const queryParams = new URLSearchParams(params);
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = { headers: { Authorization: "Bearer " + token } };
      const response = await api.get(`${URL.get_gallery}?${queryParams}`, config);
      if (response?.data?.status) {
        dispatch(galleryListAction(response?.data?.data));
      }
      dispatch(loading(false));
    } catch (error) {
      dispatch(loading(false));
    }
  };
};

export const addGallery = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = { headers: { Authorization: "Bearer " + token } };
      const response = await api.post(`${URL.add_gallery}`, data, config);
      if (response?.data?.status) toast.success(response?.data?.message);
      dispatch(loading(false));
      return response?.data;
    } catch (error) {
      dispatch(loading(false));
      return error?.response?.data;
    }
  };
};

export const updateGallery = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = { headers: { Authorization: "Bearer " + token } };
      const res = await api.post(`${URL.update_gallery}`, data, config);
      if (res?.data?.status) toast.success(res?.data?.message);
      dispatch(loading(false));
      return res?.data;
    } catch (error) {
      dispatch(loading(false));
      return error?.res?.data;
    }
  };
};

export const deleteGallery = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = { headers: { Authorization: "Bearer " + token } };
      const response = await api.post(`${URL.delete_gallery}`, data, config);
      if (response?.data?.status) toast.success(response?.data?.message);
      dispatch(loading(false));
      return response?.data;
    } catch (error) {
      dispatch(loading(false));
      return error?.response?.data;
    }
  };
};

// YouTube
export const getYoutube = (params) => {
  const queryParams = new URLSearchParams(params);
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = { headers: { Authorization: "Bearer " + token } };
      const response = await api.get(`${URL.get_youtube}?${queryParams}`, config);
      if (response?.data?.status) {
        dispatch(youtubeListAction(response?.data?.data));
      }
      dispatch(loading(false));
    } catch (error) {
      dispatch(loading(false));
    }
  };
};

export const addYoutube = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = { headers: { Authorization: "Bearer " + token } };
      const response = await api.post(`${URL.add_youtube}`, data, config);
      if (response?.data?.status) toast.success(response?.data?.message);
      dispatch(loading(false));
      return response?.data;
    } catch (error) {
      dispatch(loading(false));
      return error?.response?.data;
    }
  };
};

export const updateYoutube = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = { headers: { Authorization: "Bearer " + token } };
      const res = await api.post(`${URL.update_youtube}`, data, config);
      if (res?.data?.status) toast.success(res?.data?.message);
      dispatch(loading(false));
      return res?.data;
    } catch (error) {
      dispatch(loading(false));
      return error?.res?.data;
    }
  };
};

export const deleteYoutube = (data) => {
  return async (dispatch) => {
    try {
      const token = await localStorage.getItem("admin_token");
      const config = { headers: { Authorization: "Bearer " + token } };
      const response = await api.post(`${URL.delete_youtube}`, data, config);
      if (response?.data?.status) toast.success(response?.data?.message);
      dispatch(loading(false));
      return response?.data;
    } catch (error) {
      dispatch(loading(false));
      return error?.response?.data;
    }
  };
};


// Users
export const getUsers = (params) => {
  const queryParams = new URLSearchParams(params);

  return async (dispatch) => {
    try {
      const token = localStorage.getItem("admin_token");

      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };

      const response = await api.get(
        `${URL.get_users}?${queryParams}`,
        config
      );

      if (response?.data?.status) {
        dispatch(userListAction(response?.data?.data));
      } else {
        toast.error(response?.data?.message, {
          toastId: "getUsers",
        });

        dispatch(userListAction(response?.data?.data || {}));
      }

      dispatch(loading(false));
    } catch (error) {
      dispatch(loading(false));
      toast.error(
        error?.response?.data?.message || "Failed to fetch users"
      );
    }
  };
};

